import { useFormikContext } from "formik";
import { useEffect } from "react";

export const ScrollToErrors = () => {
  const { errors, isSubmitting } = useFormikContext();

  useEffect(() => {
    if (Object.keys(errors).length > 0 && !isSubmitting) {
      const element = document.querySelector(".is-invalid");
      if (element) {
        const headerOffset = 100;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition =
          elementPosition + window.pageYOffset - headerOffset;
        window.scrollTo({ behavior: "smooth", top: offsetPosition });
      }
    }
  }, [isSubmitting]);
  return null;
};
